// extracted by mini-css-extract-plugin
module.exports = {"MainWrapper":"index_MainWrapper__KqF_Q"};